import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { MyTimer } from '@/shared/ui/MyTimer';


interface PropsTimerMatch {
  text: string,
  date: string,
}

export const TimerMatch:FC<PropsTimerMatch> = observer(({text, date}) => {
  if(!date) return null;
  return (
    <div className="forecast-timer">
      <p className='forecast-timer_text'>{text}</p>
      <MyTimer date={date} />
    </div>  
  );


});